import { ReactElement } from "react";
import { NavLink } from "./NavLink";
import { LINKS, URL } from "myconstants";
import { Link } from "react-router-dom";

export function Navigation(): ReactElement {
  return (
    <nav className="pl-16 pt-16 w-72 border-r-2 border-r-gray-100 text-right">
      <ul className="w-auto">
        <li className="p-2 font-bold border-b text-gray-700">Rechtskräftiger Zonenplan</li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanLegalCalculation}>
            {LINKS[URL.zoningPlanLegalCalculation]}
          </NavLink>
        </li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanLegalUndevelopedBuildingZones}>
            {LINKS[URL.zoningPlanLegalUndevelopedBuildingZones]}
          </NavLink>
        </li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanLegalSiteSpecificValues}>
            {LINKS[URL.zoningPlanLegalSiteSpecificValues]}
          </NavLink>
        </li>
        <li className="p-2"></li>
        <li className="p-2 font-bold border-b text-gray-700">
          <Link to={URL.zoningPlanDraft}>Zonenplan<br/>mit / ohne Vorwirkung</Link>
        </li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanDraftUpload}>
            {LINKS[URL.zoningPlanDraftUpload]}
          </NavLink>
        </li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanDraftSiteSpecificValues}>
            {LINKS[URL.zoningPlanDraftSiteSpecificValues]}
          </NavLink>
        </li>
        <li className="p-2 border-b">
          <NavLink to={URL.zoningPlanDraftCalculation}>
            {LINKS[URL.zoningPlanDraftCalculation]}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
